const SOURCE_NAMES: Record<string, string> = {
  'vickypham.com': 'Vicky Pham',
  'thewoksoflife.com': 'Woks of Life',
  'hungryhuy.com': 'Hungry Huy',
  'justonecookbook.com': 'Just One Cookbook',
  'delightfulplate.com': 'Delightful Plate',
  'maangchi.com': 'Maangchi',
  'hot-thai-kitchen.com': 'Hot Thai Kitchen',
  'helenrecipes.com': "Helen's Recipes",
  'redhousespice.com': 'Red House Spice',
  'mykoreankitchen.com': 'My Korean Kitchen',
  'runawayrice.com': 'Runaway Rice',
  'yummytoddlerfood.com': 'Yummy Toddler Food',
  'weelicious.com': 'Weelicious',
  'momables.com': 'MOMables',
  'mjandhungryman.com': 'MJ & Hungryman',
  'thrivinghomeblog.com': 'Thriving Home',
  'kidseatincolor.com': 'Kids Eat in Color',
  'bucketlisttummy.com': 'Bucket List Tummy',
  'pickyeaterblog.com': 'Picky Eater',
  'creativenourish.com': 'Creative Nourish',
  'therealfooddietitians.com': 'Real Food Dietitians',
  'sarahremmer.com': 'Sarah Remmer',
};

export function sourceNameForHost(host: string | null | undefined): string | null {
  if (!host) return null;
  const norm = host.replace(/^www\./, '').toLowerCase().trim();
  if (!norm) return null;
  return SOURCE_NAMES[norm] ?? norm;
}

export function sourceNameForUrl(url: string | null | undefined): string | null {
  if (!url) return null;
  try {
    return sourceNameForHost(new URL(url).hostname);
  } catch {
    return null;
  }
}
